export default {
  marketplace: {
    common: {
      category: "Category",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      products: "Products",
      enable: "Enable",
      disabled: "Disabled",
      filterBy: "Filter By",
      back: "Back",
      next: "Next",
      delete: "Delete",
      deleteConfirmText: "Are you sure you want to delete this item?",
      statusChangeText:
        "Are you sure you want to change the status of this item?",
      itemRemovedSuccessfully: "Item removed successfully",
      changeStatus: "Change Status",
      statusUpdatedSuccessfully: "Status updated successfully.",
      clearAll: "Clear All",
      countries: "Countries",
    },
    category: {
      categories: "Categories",
      requestNewCategory: "Request New Category",
      noCategoryFound: "No Categories founds",
      createdByAdmin: "Created by Admin",
      hsCode: "HS Code",
      subcategories: "Subcategories",
      products: "Products",
      dateAdded: "Date Added",
      image: "Image",
      mainCategoryFieldRequired: "Main Category fields is required",
      categoryFieldRequired: "Category Title fields is required",
    },
    orders: {
      orders: "Orders",
      search: "Serach",
      ordersForAdmin: "Orders for Admin",
      filterBy: "Filter By",
      noOrdersFound: "No Orders found",
      orderId: "Order ID",
      product: "Product",
      products: "Products",
      sellerName: "Seller Name",
      buyerName: "Buyer Name",
      quantity: "Quantity",
      totalQuantity: "Total Quantity",
      totalPrice: "Total Price",
      dateSold: "Date Sold",
      status: "Status",
      date: "Date",
      month: "Month",
      year: "Year",
      specificDate: "Specific Date",
      range: "Range",
      category: "Category",
      selectCategory: "Select Category",
      subcategory: "Sub Category",
      selectSubcategory: "Select Sub Category",
      orderStatus: "Order Status",
      pending: "Pending",
      processing: "Processing",
      packing: "Packing",
      shipped: "Shipped",
      readyForPickup: "Ready for Pick-up",
      delivered: "Delivered",
      cancelled: "Cancelled",
      type: "Type",
      productPriceQuote: "Product Price Quote",
      shippingQuote: "Shipping Quote",
      pickUp: "Pick-up",
      clearAll: "Clear All",
      orderDetails: "OrderDetails",
      allOrders: "All Orders",
      cancelOrder: "Cancel Order",
      processOrder: "Process Order",
      messages: "Messages",
      packingSlip: "Packing Slip",
      addShippingCost: "Add Shipping Cost",
      qty: "Qty",
      price: "Price",
      discountCoupon: "Discount Coupon",
      shippingCharges: "Shipping Charges",
      deliveryAddress: "Delivery Address",
      contactNumber: "Contact Number",
      generalInformation: "General Information",
      orderDate: "Order Date",
      paymentOption: "Payment Option",
      buyerDetail : "Buyer Detail", 
      orderStatusHistory: "Order Status History",
      cancelOrderConfirmation: "Are you sure you want to cancel this order?",
      cancelOrderSuccess: "Order cancelled successfully",
      update: "Update",
      processOrderSuccess: "Order processed successfully",
    },
    products: {
      noProductFound: "No products found",
      skuCode: "SKU Code",
      mainCategory: "Main Category",
      productName: "Product Name",
      addProduct: "Add Product",
      createdBy: "Created by",
      quantity: "Quantity",
      orders: "Orders",
      price: "Price",
      changeStatus: "Change Status",
      memberProducts: "Member Products",
      generalInformation: "General Information",
      classification: "Classification",
      pricing: "Pricing",
      shipping: "Shipping",
      addImage: "Add Image",
      addMultipleImages: "Add multiple images",
      description: "Description",
      attachFiles: "Attach Files",
      addFiles: "Add Files",
      productNameRequired: "Product name field is required",
      productSkuCodeRequired: "Product SKU code field is required",
      descriptionRequired: "Product description is required",
      productSKUCode: "Product SKU Code",
      productCategory: "Product Category",
      productSubcategory: "Product Subcategory",
      productFarm: "Product Farm",
      productExpiration: "Product Expiration",
      quantityAvailable: "Quantity Available",
      warehouse: "Warehouse",
      preOrder: "Pre-Order",
      minimumOrderQuantity: "Minimum Order Quantity",
      typeQuantity: "Type Quantity",
      selectDate: "Select date",
      makeASelection: "Make a selection",
      selectProductCategory: "Select product category",
      selectProductFromWarehouse: "Select product from warehouse",
      selectProductAvailabilityDate: "Select product available date",
      removeFile: "Remove file",
      fileAdded: "File added",
      replaceFile: "Replace file",
      quoteRequest: "Quote Request",
      addMorePricingSlabs: "Add More Pricing Slabs",
      currency: "Currency",
      qtyUpTo: "Qty up to",
      unit: "Unit",
      promotion: "Promotion",
      packagingUnit: "Packaging Unit",
      bag: "Bag",
      case: "Case",
      palletSize: "Pallet Size",

      productVisibility: "Product Visibility",
      deliveryOptions: "Delivery Options",
      local: "Local",
      worldwide: "WorldWide",
      selectedCountries: "Selected Countries",
      selectCountries: "Select Countries",
      delivery: "Delivery",
      deliveryCharges: "Delivery Charges",
      freeDelivery: "Free Delivery",
      fullDeliveryCharge: "Buyer Will Pay Full Delivery Charges",
      partialDeliveryCharge: "Buyer Will Pay Percentage of Delivery Charges",
      pickup: "Pickup",
      productAvailableTime: "Product Availability Time",
      percentageDeliveryCharge: "Percentage Delivery Charge",
      public: "Public",
      private: "Private",
      country: "Country",
      addProductSuccessMsg: "Your Product has been successfully registered",
    },
    sellers: {
      sellers: "Sellers",
      addSeller: "Add Seller",
      searchBySeller: "Search by Seller Name",
      noDataFound: "No Data Found",
      youHaveNotAddedAnySellerYet: "You have not added any seller yet.",
      pleaseAddTheSellersToStart: "Please add the sellers to start",
      filter: {
        product: "Product",
        category: "Category",
        countries: "Countries",
        noOfProducts: "No. of Products",
        noOfOrders: "No. of Orders",
        sellerStatus: "Seller Status",
        from: "From",
        to: "To",
        of: "Of",
        selectProduct: "Select Product",
      },
      tableHeaders: {
        name: "Name",
        email: "Email",
        country: "Country",
        noOfProducts: "No. of Products",
        noOfOrders: "No. of Orders",
        status: "Status",
        cityTown: "City/Town",
      },
      active: "Active",
      deactivated: "Deactivated",
      activateDeactivate: "Activate/Deactivate",
      headerTitleActivate: "Activate account",
      headerTitleDeactivate: "Deactivate account",
      deactivateConfirmationText: "Are you sure you want to deactivate",
      reasonLabel: "Reason",
      predefinedRangeLabel: "Predefined Range from Current Date",
      rangeOneDay: "One Day",
      rangeOneWeek: "One Week",
      rangeOneMonth: "One Month",
      rangeLifetime: "Lifetime",
      rangeCustom: "Custom",
      fromDateLabel: "From",
      toDateLabel: "To",
      activationDateLabel: "Activation Date:",
      deactivationReasonLabel: "Reason for deactivation:",
      activateConfirmationText: "Are you sure you want to activate",
      activateLabel: "Activate",
      cancelButton: "CANCEL",
      completeButton: "Complete",
      deactivateButton: "Deactivate account",
      deactivateSuccessMessage: "Account deactivated successfully",
      deactivateErrorMessage: "Error deactivating account",
      reactivateSuccessMessage: "Account reactivated successfully",
      reactivateErrorMessage: "Error reactivating account",
    },
    settings: {
      header: "Marketplace settings",
      addMoreLabel: "Add more",
      generalSettingHeader: "General Settings",
      settingHeader: "My Sellers Account Settings",
      editSettingsBtn: "Edit Settings",
      numberOfProductHeading: "Number of Products Setup",
      numberOfProduct: "Number of Products",
      storeSettingHeading: "My Store Settings",
      bankAccountHeading: "Setup / Edit Bank Account",
      editBankAccountBtn: "Manage Bank Account",
      paypalAccountHeading: "Setup / Edit PayPal Account",
      editPaypalAccountBtn: "Manage PayPal Account",
      pickupLocationsHeading: "Setup / Edit Pickup Location",
      editPickupLocationBtn: "Manage Pickup Location",
      phoneNumberLabel: "Phone number",
      defaultCurrencyLabel: "Default Currency",
      businessHoursLabel: "Business Hours",
      notificationSettingsHeader: "Notification Settings",
      phoneNumberPlaceHolder: "Enter Phone Number",
      emailPlaceHolder: "Enter Email",
      currencyPlaceHolder: "Select Currency",
      timingLabel: "Timing",
      selectTiming: "Select Timing",
      bankAccounts: "Bank Accounts",
      phoneMobile: "Phone(Mobile)",
      phoneHome: "Phone(Home)",
      cityTown: "City/Town",
      addBankAccountBtn: "Add Bank Account",
      addPaypalAccountBtn: "Add PayPal Account",
      addPickupLocationBtn: "Add Pickup Location",
      accountTitle: "Account Title",
      bankLabel: "Bank",
      typeHere: "Type here",
      paypalAccounts: "PayPal Accounts",
      paypalAccount: "PayPal Accounts",
      pickupLocations: "Pickup Locations",
      addThisAddress: "Add this address",
      businessHours: "Business Hours",
      timezone: "Timezone",
      selectTimezone: "Select Timezone",
      businessDays: "Business Days",
      searchLocation: "Search Location",
      notification: "Notification",
      notificationTitle: "Notification Title",
      notificationFrequency: "Notification Frequency",
      notificationMode: "Notification Mode",
    },
    dashboard:{
      title: "Marketplace Dashboard",
      marketplace: "Marketplace",
      viewAll: "View All",
      topChart: "Top Charts",
      today: "Today",
      week: "Week",
      month: "Month",
      year: "Year",
      categories: "Categories",
      sellers: "Sellers",
      products: "Products",
      orders: "Orders",
      total: "Total",
      localtradevsexport: "Local Trade vs Export",
      exportAsPdf: "Export as PDF",
      exportAsCsv: "Export as CSV",
      export: "Export",
      selectProductCategory: "Select Product Category",
      trade: "Trade",
      main: "Main",
      subcategories: "Subcategories",
      active: "Active",
      inactive: "Inactive",
      completed: "Completed",
      settings: "Settings",
    },
  },
}
